import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type {
    OrderCommandCommon} from "@@/shared/orders/commands/order-commands-common";
import {
    orderCommandCommonZodSchema,
} from "@@/shared/orders/commands/order-commands-common";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type OrderReadyForPickupCommand = OrderCommandCommon & {
    readonly _type: "ORDER_READY_FOR_PICKUP_COMMAND";
    readonly numberOfPackages?: number;
    readonly ignoreCustomerNotification?: boolean;
};

type FactoryParams = Except<
    OrderReadyForPickupCommand,
    "_id" | "_type" | "_createdAt"
>;
const orderReadyForPickupCommandFactory = (params: FactoryParams) => {
    const orderReadyForPickup: OrderReadyForPickupCommand = {
        ...params,
        _id: generateId({ prefix: "order_ready_for_pickup_command__" }),
        _type: "ORDER_READY_FOR_PICKUP_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return orderReadyForPickup;
};

const orderReadyForPickupCommandZodSchema: z.ZodSchema<OrderReadyForPickupCommand> =
    orderCommandCommonZodSchema.and(
        z.object({
            _type: z.literal("ORDER_READY_FOR_PICKUP_COMMAND"),
            numberOfPackages: z.number().int().optional(),
        }),
    );

export {
    orderReadyForPickupCommandFactory as createOrderReadyForPickupCommand,
    orderReadyForPickupCommandZodSchema,
};
export type { OrderReadyForPickupCommand };
